import { createExternalStore } from 'providers/createStore';

import { MAX_BREAKPOINTS, ResponsiveBreakpoint } from 'styles';

export interface UseWindowSize {
  height: number;
  width: number;

  /**
   * Indicates if a given breakpoint is active.
   */
  breakpoints: {
    [K in ResponsiveBreakpoint]: boolean;
  };
}

export function getCurrentSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,

    breakpoints: Object.fromEntries(
      Object.entries(MAX_BREAKPOINTS).map(([breakpoint, maxWidth]) => [
        breakpoint,
        window.innerWidth <= maxWidth,
      ]),
    ),
  } as UseWindowSize;
}

let windowSize = getCurrentSize();

export const { setWindowSize, useIsBreakpoint, useWindowSize } = createExternalStore({
  actions: {
    setWindowSize(size: UseWindowSize) {
      windowSize = size;
    },
  },

  selectors: {
    isBreakpoint(breakpoint?: ResponsiveBreakpoint) {
      if (!breakpoint) return false;

      return !!windowSize.breakpoints?.[breakpoint];
    },

    windowSize() {
      return windowSize;
    },
  },
});
